import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';

import { UntypedFormBuilder, UntypedFormControl } from '@angular/forms';

import {
  injectComponentTelemetryService,
  EnableComponentTelemetry,
  EnableClassTelemetry,
} from 'app/services/otel.service';

export interface PaginationEvent {
  pageIndex: number;
  pageSize: number;
}

@EnableClassTelemetry()
@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss'],
  standalone: false,
})
export class PaginatorComponent implements OnInit, OnChanges {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();
  @Input() length: number;
  @Input() pageIndex: number;
  @Input() pageSize: number;
  @Input() pageSizeOptions: number[];

  @Output() pageChanged: EventEmitter<PaginationEvent> = new EventEmitter<PaginationEvent>();

  allPagesCount = 0;

  pageIndexControl: UntypedFormControl;

  constructor(formBuilder: UntypedFormBuilder) {
    this.pageIndexControl = formBuilder.control('');
  }

  ngOnInit(): void {
    this.calculateAllPagesCount();

    this.updatePageIndexControl();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.length && !changes.length.firstChange) {
      this.calculateAllPagesCount();
    }
  }

  private emitPageChanged() {
    this.pageChanged.emit({
      pageIndex: this.pageIndex,
      pageSize: this.pageSize,
    });
  }

  onPageIndexChanged(): void {
    const value = this.pageIndexControl.value;
    if (value && value > 0 && value <= this.allPagesCount) {
      if (value !== this.pageIndexDisplay) {
        this.pageIndex = value - 1;

        this.emitPageChanged();
      }
    } else {
      if (this.pageIndex !== 0) {
        this.pageIndex = 0;

        this.emitPageChanged();
      }

      this.updatePageIndexControl();
    }
  }

  onPageSizeChanged(): void {
    this.emitPageChanged();

    this.calculateAllPagesCount();
  }

  onStepBack(): void {
    if (!this.canNotStepBack) {
      this.pageIndex--;
      this.updatePageIndexControl();

      this.emitPageChanged();
    }
  }

  onStepForward(): void {
    if (!this.canNotStepForward) {
      this.pageIndex++;
      this.updatePageIndexControl();

      this.emitPageChanged();
    }
  }

  private updatePageIndexControl() {
    this.pageIndexControl.setValue(this.pageIndexDisplay);
  }

  private calculateAllPagesCount(): void {
    this.allPagesCount = Math.ceil(this.length / this.pageSize);
  }

  get pageIndexDisplay() {
    return this.pageIndex + 1;
  }

  get canNotStepBack() {
    return this.pageIndex === 0;
  }

  get canNotStepForward() {
    return this.pageIndex === this.allPagesCount - 1;
  }
}
